import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  return <>
      <motion.nav initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-6 md:px-12 max-w-7xl mx-auto w-full backdrop-blur-sm bg-[#0a0a0a]/80" data-id="element-136">
        <div className="flex items-center gap-2 z-50" data-id="element-137">
          <div className="w-8 h-8 bg-[#ff6b35] rounded-full flex items-center justify-center" data-id="element-138">
            <span className="font-bold text-white text-lg font-['Syne']" data-id="element-139">
              M
            </span>
          </div>
          <span className="font-bold text-xl tracking-tight font-['Syne']" data-id="element-140">
            Mockup.ai
          </span>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-[#a3a3a3]" data-id="element-141">
          <a href="#features" className="hover:text-white transition-colors" data-id="element-142">
            Features
          </a>
          <a href="#how-it-works" className="hover:text-white transition-colors" data-id="element-143">
            How it works
          </a>
          <a href="#pricing" className="hover:text-white transition-colors" data-id="element-144">
            Pricing
          </a>
        </div>

        <div className="hidden md:flex items-center gap-4" data-id="element-145">
          <a href="#" className="text-sm font-medium hover:text-[#ff6b35] transition-colors" data-id="element-146">
            Log in
          </a>
          <button className="bg-white text-black px-4 py-2 rounded-full text-sm font-bold hover:bg-[#e5e5e5] transition-colors" data-id="element-147">
            Get Started
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden z-50 text-white p-2" onClick={toggleMenu} data-id="element-148">
          {isMenuOpen ? <X data-id="element-149" /> : <Menu data-id="element-150" />}
        </button>
      </motion.nav>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-151">
        {isMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="fixed inset-0 z-40 bg-[#0a0a0a] pt-24 px-6 md:hidden flex flex-col gap-8" data-id="element-152">
            <div className="flex flex-col gap-6 text-2xl font-bold font-['Syne']" data-id="element-153">
              <a href="#features" onClick={toggleMenu} className="hover:text-[#ff6b35]" data-id="element-154">
                Features
              </a>
              <a href="#how-it-works" onClick={toggleMenu} className="hover:text-[#ff6b35]" data-id="element-155">
                How it works
              </a>
              <a href="#pricing" onClick={toggleMenu} className="hover:text-[#ff6b35]" data-id="element-156">
                Pricing
              </a>
            </div>

            <div className="mt-auto mb-12 flex flex-col gap-4" data-id="element-157">
              <button className="w-full bg-white text-black py-4 rounded-full font-bold" data-id="element-158">
                Get Started
              </button>
              <button className="w-full border border-[#333] text-white py-4 rounded-full font-bold" data-id="element-159">
                Log in
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}